import React, { Component } from "react";
import { debounce } from "lodash";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as ParticipantsActions,
  Selectors as ParticipantsSelectors,
} from "store/ducks/participants";
import {
  Creators as InterviewsActions,
  Selectors as InterviewsSelectors,
} from "store/ducks/interviews";

import { Form } from "components";

class CustomForm extends Component {
  constructor(props) {
    super(props);

    const { searchParticipantsByDocumentRequest } = props;

    this.handleSearchParticipants = debounce(
      searchParticipantsByDocumentRequest,
      1000
    );
  }

  state = {
    data: this.props.data,
  };

  componentDidMount() {
    const { getInterviewableRequest } = this.props;

    getInterviewableRequest();
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleChangeInput = (e) => {
    const { data } = this.state;
    const { name, value } = e.target;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleChangeSelect = (name, value) => {
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleTriggerSearchParticipants = (value) => {
    if (value !== null && value !== "") {
      this.handleSearchParticipants(value);
    }
  };

  handleToggleBlingParticipant = (e) => {
    e.preventDefault();
    const { data } = this.state;

    this.setState({ data: { ...data, blind_participant: !data.blind_participant } })
  }

  render() {
    const { data } = this.state;
    const { errors, isUpdate, participants, journeys } = this.props;

    return (
      <Form onSubmit={this.onSubmit}>
        <div className="row">
          <div className="col-6">
            <Form.Group>
              <Form.Label>Curso</Form.Label>
              <Form.Input
                name="course"
                placeholder="Nome do curso"
                focus={1}
                value={data.course}
                errors={errors.course}
                onChange={this.handleChangeInput}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Turma</Form.Label>
              <Form.Input
                name="course_class"
                placeholder="Nome da turma"
                value={data.course_class}
                errors={errors.course_class}
                onChange={this.handleChangeInput}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Aluno</Form.Label>
              {isUpdate ? (
                <Form.Input
                  name="name"
                  placeholder="Aluno"
                  disabled={isUpdate}
                  value={data.name}
                  errors={errors.name}
                  onChange={this.handleChangeInput}
                />
              ) : (
                <Form.Select
                  placeholder="E-mail do Aluno"
                  noOptionsMessage={() => "Procurar participante"}
                  options={participants.data}
                  value={data.person}
                  errors={errors.person}
                  onInputChange={this.handleTriggerSearchParticipants}
                  onChange={(value) => this.handleChangeSelect("person", value)}
                />
              )}
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Jornada</Form.Label>
              <Form.Select
                name="journey"
                placeholder="Selecione o tipo"
                isDisabled={isUpdate}
                options={journeys.data}
                value={data.journey}
                errors={errors.journey}
                onChange={(value) => this.handleChangeSelect("journey", value)}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Calculado em</Form.Label>
              <Form.DatePicker
                name="calculated_at"
                placeholderText="Data"
                timeFormat="HH:mm"
                dateFormat="dd/MM/yyyy HH:mm"
                timeCaption="Hora"
                showTimeSelect
                timeIntervals={15}
                errors={errors.calculated_at}
                selected={data.calculated_at}
                ref={(input) => {
                  this.input = input;
                }}
                onChange={(value) =>
                  this.handleChangeSelect("calculated_at", value)
                }
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>Facilitador(a)/Coach (Email)</Form.Label>
              <Form.Input
                name="coach_email"
                placeholder="Facilitador(a)/Coach (Email)"
                value={data.coach_email}
                errors={errors.coach_email}
                onChange={this.handleChangeInput}
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group >
              <Form.Checkbox
                name="blind_participant"
                label="Comunicar entrevistado por email?"
                value={data.blind_participant}
                checked={data.blind_participant}
                onChange={this.handleToggleBlingParticipant}
              />
            </Form.Group>
          </div>
        </div>
      </Form>
    );
  }
}

CustomForm.defaultProps = {
  isUpdate: false,
};

const mapState = (state) => ({
  participants: {
    ...state.participants.searchByDocument,
    data: ParticipantsSelectors.search(
      state.participants.searchByDocument.data
    ),
  },
  journeys: {
    ...state.interviews.interviewable,
    data: InterviewsSelectors.interviewable(
      state.interviews.interviewable.data
    ),
  },
});

const mapActions = (dispatch) =>
  bindActionCreators(
    { ...ParticipantsActions, ...InterviewsActions },
    dispatch
  );

export default connect(mapState, mapActions)(CustomForm);



// WEBPACK FOOTER //
// ./src/pages/Admin/Interviews/components/Form/index.js